/* eslint-disable jsx-a11y/anchor-is-valid */
import {Column} from 'react-table'
import {KTableProvider, useKTable} from '../../../../../../../../contexts/KTableProvider'
import {KTable, KTableHeader, KTableLoading} from '../../../../../../../../components/UI'
import React, {FC, useEffect, useState} from 'react'
import {KTCard, KTSVG} from '../../../../../../../../../../_metronic/helpers'
import {AppTypeClothe, AppFormLaundry, Reception} from '../../../../../../model'
import {getAppLaundryById, getAppLaundryPrint} from '../../../../../../services'
import {InputDate, InputText} from '../../../../../../../../components/UI/Input'
import {Select} from '../../../../../../../../components/UI/Select'
import {useForm, FormProvider} from 'react-hook-form'
import {useLavanderia} from '../../../../../../../../hooks/useLavanderia'
import {getMasterService} from '../../../../../../../central/services'
import {ModalClothe} from '../Modal/ModalClothe'
const TableDetail: FC = () => {
  const {data, setData, loading, setLoading} = useKTable()
  const {currentTabItem, isAllowed} = useLavanderia()
  const [showModalNew, setShowModalNew] = useState(false)
  const [showOption, setShowOption] = useState<string>('')
  const [idPermission, setIdPermission] = useState<any>('')
  const [minLength, setMinLength] = useState<string>('')
  const [typeFurnitureLavado, setTypeFurnitureLavado] = useState<Reception[] | any>([])

  const [detailpermission, setDetailPermission] = useState<AppTypeClothe | any>(null)
  const methods = useForm<AppFormLaundry>()
  const [typeFurniture, setTypeFurniture] = useState<Reception[] | any>([])
  const {
    control,
    setValue,
    handleSubmit,
    register,
    formState: {errors},
  } = methods

  const getLaundryByIdList = async () => {
    const response = await getAppLaundryById(currentTabItem.idToEdit)
    const data = response.data.data
    let tempData =
      data.detalle?.map((item: any, index: any) => {
        return {...item, item: index + 1}
      }) || []
    setData(tempData)
    setLoading(false)
    let nombreResopnsable = data.huespedId ? data.huesped : data.colaborador
    setValue('responsable', nombreResopnsable)
    let lugarRecep = data.recepcion.lugarRecepcion ? data.recepcion.lugarRecepcion : ''
    setValue('lugarRecepcion', lugarRecep)
    let lugarLav = data.procesoLavado.lugarLavado ? data.procesoLavado.lugarLavado : ''
    setValue('lugarLavado', lugarLav)
    const fechaLocalSalida = data.salida.fechaSalida ? new Date(data.salida.fechaSalida) : null
    const formattedDateSalida = fechaLocalSalida ? fechaLocalSalida.toISOString().slice(0, 10) : ''
    setValue('fechaRecepcion', formattedDateSalida)
    const fechaLocal = data.recepcion.fechaRecepcion
      ? new Date(data.recepcion.fechaRecepcion)
      : null
    const formattedDate = fechaLocal ? fechaLocal.toISOString().slice(0, 10) : ''
    setValue('fechaRecepcion', formattedDate)
    const fechaLocalProgramada = data.recepcion.fechaProgramada
      ? new Date(data.recepcion.fechaProgramada)
      : null
    const formattedDateProgramada = fechaLocalProgramada
      ? fechaLocalProgramada.toISOString().slice(0, 10)
      : ''
    setMinLength(formattedDate)
    setValue('fechaProgramada', formattedDateProgramada)
    let countTotal =
      data.detalle?.reduce((acumulador: any, elemento: any) => acumulador + elemento.cantidad, 0) ||
      0
    let sumWeight =
      data.detalle?.reduce((acumulador: any, elemento: any) => acumulador + elemento.peso, 0) || 0
    setValue('pesoTotal', sumWeight)
    setValue('cantidadTotal', countTotal)
    setValue('bolsaCorrelativo', data.bolsaCorrelativo)
    setValue('rotuladoCorrelativo', data.rotuladoCorrelativo)
    let status = data.tipoRecepcion ? data.tipoRecepcion : ''
    setShowOption(status)
  }

  const getReceptionPlaceList = async () => {
    try {
      const response = await getMasterService({
        pageNumber: 1,
        size: 100,
        tableName: 'LugarEntrega',
      })
      const data = response.data.data || []
      const mappedMaster = data.map((master) => ({
        value: master.codigo.toString(),
        label: master.nombreCorto,
      }))
      setTypeFurniture(mappedMaster)
    } catch (error) {
      console.error('Error al obtener la lista de tipo de documento:', error)
    }
  }
  const getReceptionPlaceLavadoList = async () => {
    try {
      const response = await getMasterService({
        pageNumber: 1,
        size: 100,
        tableName: 'LugarLavadoLavanderia',
      })
      const data = response.data.data || []
      const mappedMaster = data.map((master) => ({
        value: master.codigo.toString(),
        label: master.nombreCorto,
      }))
      setTypeFurnitureLavado(mappedMaster)
    } catch (error) {
      console.error('Error al obtener la lista de tipo de documento:', error)
    }
  }
  useEffect(() => {
    getLaundryByIdList()
    getReceptionPlaceList()
    getReceptionPlaceLavadoList()
  }, [])

  const handleEdit = (item: AppTypeClothe) => {
    const filter = data.filter((detail) => detail.id === item.id)
    setDetailPermission(filter[0])
    setIdPermission(item.id)
    setShowModalNew(true)
  }
  const downloadOrderPrint = async () => {
    try {
      const response = await getAppLaundryPrint(currentTabItem.idToEdit)
      const blob = new Blob([response.data], {type: 'application/pdf'})
      // Crea un enlace temporal y simula un clic para descargar el archivo
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = 'Ticket_detallado_' + currentTabItem.idToEdit // Ajusta el nombre del archivo según tus necesidades
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    } catch (error) {}
  }
  const columns: Column<AppTypeClothe>[] = [
    {
      Header: (props) => <KTableHeader tableProps={props} title='Item' />,
      accessor: 'item',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Tipo de ropa' />,
      accessor: 'tipoRopa',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Cantidad' />,
      accessor: 'cantidad',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Peso KG' />,
      accessor: 'peso',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Observaciones' />,
      accessor: 'observacionColor',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Ver' />,
      id: 'actions',
      Cell: ({...props}) => (
        <>
          {isAllowed('DETALLE/VER')
            ? showOption === 'SISTEMA' && (
                <div
                  className='d-flex justify-content-center flex-shrink-0'
                  onClick={() => handleEdit(props.data[props.row.index])}
                >
                  <a href='#' className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'>
                    <KTSVG path='/media/icons/duotune/general/gen004.svg' className='svg-icon-3' />
                  </a>
                </div>
              )
            : null}
        </>
      ),
    },
  ]

  useEffect(() => {
    setLoading(loading)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading])

  return (
    <>
      <KTCard shadow className='m-5'>
        <div className='p-2'>
          <FormProvider {...methods}>
            <form>
              <div className='row'>
                <div className='col-sm-12 col-lg-3'>
                  <label className='required'>Lugar de recepción</label>
                  <Select
                    control={control}
                    name='lugarRecepcion'
                    data={typeFurniture}
                    errors={errors}
                    disabled={true}
                  />
                </div>
                <div className='col-sm-12 col-lg-3'>
                  <label className='required'>Colaborador</label>
                  <InputText
                    name='responsable'
                    register={register}
                    errors={errors}
                    disabled={true}
                  />
                </div>
                <div className='col-sm-12 col-lg-3'>
                  <label>Fecha de recepción:</label>
                  <InputDate
                    name='fechaRecepcion'
                    register={register}
                    errors={errors}
                    disabled={true}
                  />
                </div>
                <div className='col-sm-12 col-lg-3'>
                  <label className='required'>Lugar de lavado</label>
                  <Select
                    control={control}
                    name='lugarLavado'
                    data={typeFurnitureLavado}
                    errors={errors}
                    disabled={true}
                  />
                </div>

                <div className='row'>
                  <div className='col-sm-12 col-lg-2'>
                    <label>Cantidad total:</label>
                    <InputText
                      name='cantidadTotal'
                      register={register}
                      errors={errors}
                      disabled={true}
                    />
                  </div>
                  <div className='col-sm-12 col-lg-2'>
                    <label>Peso total:</label>
                    <InputText
                      name='pesoTotal'
                      register={register}
                      errors={errors}
                      disabled={true}
                    />
                  </div>
                  <div className='col-sm-12 col-lg-2'>
                    <label>Bolsa:</label>
                    <InputText
                      name='bolsaCorrelativo'
                      register={register}
                      errors={errors}
                      disabled={true}
                    />
                  </div>
                  <div className='col-sm-12 col-lg-2'>
                    <label>Rotulado:</label>
                    <InputText
                      name='rotuladoCorrelativo'
                      register={register}
                      errors={errors}
                      disabled={true}
                    />
                  </div>
                  <div className='col-sm-12 col-lg-2'>
                    <label>Fecha programada:</label>
                    <InputDate
                      name='fechaProgramada'
                      register={register}
                      errors={errors}
                      minValue={minLength}
                      disabled={true}
                    />
                  </div>
                  <div className='col-sm-12 col-lg-2'>
                    <label>Fecha Salida:</label>
                    <InputDate
                      name='fechaSalida'
                      register={register}
                      errors={errors}
                      minValue={minLength}
                      disabled={true}
                    />
                  </div>
                </div>

                <div className='col-sm-12 col-lg-12 d-flex justify-content-end align-items-end'>
                  <div className='d-flex justify-content-end'>
                    {isAllowed('DETALLE/DESCARGAR_BOLETA') && (
                      <button
                        type='button'
                        className='btn btn-success me-3'
                        onClick={handleSubmit(downloadOrderPrint)}
                      >
                        Descargar boleta
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </form>
          </FormProvider>
        </div>
        {isAllowed('DETALLE/LISTAR') && (
          <>
            <KTable data={data} columns={columns} />
            {loading ? <KTableLoading title='Cargando...' /> : null}
          </>
        )}
        <ModalClothe
          show={showModalNew}
          setShow={setShowModalNew}
          idPermission={idPermission}
          detailpermission={detailpermission}
        />
      </KTCard>
    </>
  )
}

const TableDetailWrapper = () => {
  return (
    <KTableProvider>
      <TableDetail />
    </KTableProvider>
  )
}
export {TableDetailWrapper}
